import type { ElementType, HTMLAttributes, ReactNode } from 'react';
import styles from './SerifHeading.module.css';

type Level = 'xl' | 'lg' | 'md' | 'sm';

type SerifHeadingProps = HTMLAttributes<HTMLElement> & {
  level?: Level;
  as?: ElementType;
  children: ReactNode;
};

const levelClass: Record<Level, string> = {
  xl: styles.xl,
  lg: styles.lg,
  md: styles.md,
  sm: styles.sm,
};

/**
 * Instrument Serif display heading. Four sizes matching the typography
 * spec (evaluation-and-tokens §3.2): xl (clamp 44-72), lg (clamp 32-44),
 * md (32), sm (24).
 *
 * Italic via `<em>` inside — reserved for emphasis moments (brand
 * tagline, key nouns in hero copy, celebration). Color the em via an
 * inline style or component CSS so you control the signal/today
 * register per context.
 */
export function SerifHeading({
  level = 'md',
  as: Tag = 'h2',
  className,
  children,
  ...rest
}: SerifHeadingProps) {
  return (
    <Tag
      className={[styles.serif, levelClass[level], className].filter(Boolean).join(' ')}
      {...rest}
    >
      {children}
    </Tag>
  );
}
